import React from 'react';
import { TitleField } from '../../../../../../TitleField';
import { Typography } from '../../../../../../Typography';

interface DetailsPageHeaderTitleProps {
  title: string;
  isTitleEditable: boolean;
  onChange: (title: string) => void;
  isSmallDevice: boolean;
}

export const DetailsPageHeaderTitle: React.FC<DetailsPageHeaderTitleProps> = ({
  title,
  isTitleEditable,
  onChange,
  isSmallDevice,
}) => {
  if (!isTitleEditable)
    return (
      <Typography variant="h1" noWrap={true} width="100%" sx={{ cursor: 'default', fontSize: '24px' }}>
        {title}
      </Typography>
    );

  return (
    <TitleField
      data-testid="title-input"
      fullWidth={true}
      defaultValue={title}
      onBlur={(event?: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newTitle = event?.currentTarget?.value;
        if (newTitle && newTitle !== title) onChange?.(newTitle);
      }}
      aria-label={title}
      sx={{
        my: 0,
        '.MuiInputBase-input': {
          '&:focus': {
            p: `${isSmallDevice ? '10px 4px' : '0 4px'}`,
          },
          p: '0',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
};
